import React from "react";
import { Card, CardContent } from "./ui/card";
import { ScanSearch, BrainCircuit, ListChecks } from "lucide-react";

export function Features() {
  return (
    <>
    <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 mt-32 mb-32">
      <div className="p-8 rounded-lg text-left problem-card">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">Problem</h2>
        <p className="text-xl text-zinc-400">
          People want websites to work well with AI agents (like chatbots and virtual assistants) but don't know how to make that happen.
        </p>
      </div>

      <div className="p-8 rounded-lg text-left solution-card">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">Solution</h2>
        <p className="text-xl text-zinc-400">
          Make your website speak AI's language - we'll scan your site and show you exactly how to help AI agents understand and work with your content better.
        </p>
      </div>
    </div>
    <div className="grid md:grid-cols-3 gap-8 mb-20">
      <Card className="bg-[#1A1A1A] border-[#333] transform hover:scale-105 transition-all duration-300">
        <CardContent className="pt-6">
          <div className="rounded-full w-12 h-12 bg-[#222] flex items-center justify-center mb-4">
            <ScanSearch className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-xl font-semibold mb-2 text-white">Deep Scanning</h3>
          <p className="text-zinc-400">
            We analyze your site through the cold, calculating eyes of an AI.
          </p>
        </CardContent>
      </Card>
      <Card className="bg-[#1A1A1A] border-[#333] md:translate-y-8 transform hover:scale-105 transition-all duration-300">
        <CardContent className="pt-6">
          <div className="rounded-full w-12 h-12 bg-[#222] flex items-center justify-center mb-4">
            <BrainCircuit className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-xl font-semibold mb-2 text-white">AI-First Analysis</h3>
          <p className="text-zinc-400">
            Get insights from actual AI agents who've tried to parse your site.
          </p>
        </CardContent>
      </Card>
      <Card className="bg-[#1A1A1A] border-[#333] transform hover:scale-105 transition-all duration-300">
        <CardContent className="pt-6">
          <div className="rounded-full w-12 h-12 bg-[#222] flex items-center justify-center mb-4">
            <ListChecks className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-xl font-semibold mb-2 text-white">Clear Actions</h3>
          <p className="text-zinc-400">
            Receive actionable feedback that even a human could understand.
          </p>
        </CardContent>
      </Card>
    </div>
    </>
  );
} 